export type NotificationNavigation =
  | { kind: 'route'; target: string }
  | { kind: 'external'; target: string };

/** Keep same-origin notification links inside the SPA so shell page tabs survive. */
export function resolveNotificationNavigation(
  url?: string | null,
  origin = window.location.origin,
): NotificationNavigation {
  const value = (url || '').trim();
  if (!value) return { kind: 'route', target: '/notifications' };

  if (/^https?:\/\//i.test(value)) {
    try {
      const parsed = new URL(value);
      if (parsed.origin === origin) {
        return {
          kind: 'route',
          target: `${parsed.pathname}${parsed.search}${parsed.hash}` || '/',
        };
      }
    } catch {
      // Preserve the existing external-navigation behavior for malformed absolute URLs.
    }
    return { kind: 'external', target: value };
  }

  return { kind: 'route', target: value.startsWith('/') ? value : `/${value}` };
}
